/** Survives virtua remounts so chat image previews skip the spinner on revisit. */
const MAX_CACHED = 300
const loadedCookies = new Set<string>()
const insertionOrder: string[] = []

export const isChatImagePreviewCached = (fileCookie: string): boolean => {
  if (!fileCookie) return false
  return loadedCookies.has(fileCookie)
}

export const markChatImagePreviewCached = (fileCookie: string): void => {
  if (!fileCookie || loadedCookies.has(fileCookie)) return
  loadedCookies.add(fileCookie)
  insertionOrder.push(fileCookie)
  while (insertionOrder.length > MAX_CACHED) {
    const oldest = insertionOrder.shift()
    if (oldest) loadedCookies.delete(oldest)
  }
}

/** Clears preview cache (tests / session teardown). */
export const clearChatImagePreviewCache = (): void => {
  loadedCookies.clear()
  insertionOrder.length = 0
}
